import { put, select } from "typed-redux-saga";
import { setStatus } from "../dom-utils";
import { rootActions } from "../reducers/root.slice";
import ColumnUtils from "../utils/ColumnUtils";
import { selectRootState } from "../selectors";

export function* loadPrevOrNextMethod(
  action: ReturnType<typeof rootActions.loadPrevOrNextMethod>
) {
  const {
    leftPanel,
    methodColumns,
    categoricalPredictionColumns,
    continuousPredictionColumns,
    categoricalColumns,
  } = yield* select(selectRootState);

  const currentMethodIndex = methodColumns.findIndex(
    (method) => method === leftPanel.selectedMethod
  );

  let nextMethod;

  if (action.payload === "prev") {
    nextMethod = methodColumns[Math.max(0, currentMethodIndex - 1)];
  } else {
    nextMethod =
      methodColumns[Math.min(methodColumns.length - 1, currentMethodIndex + 1)];
  }

  if (!nextMethod) {
    setStatus("Invalid method: " + String(nextMethod));
    return;
  }

  if (
    leftPanel.selectedColumn &&
    ColumnUtils.isPredictionColumn(
      leftPanel.selectedColumn,
      categoricalPredictionColumns,
      continuousPredictionColumns
    )
  ) {
    yield* put(
      rootActions.setSelectedMethodAndColumn({
        method: nextMethod,
        column: ColumnUtils.getDefaultColumn({
          selectedMethod: nextMethod,
          categoricalColumns,
          categoricalPredictionColumns,
          continuousPredictionColumns,
        }),
      })
    );
  } else {
    yield* put(rootActions.setSelectedMethod(nextMethod));
  }
}
